import React, {useRef} from 'react'
import {
  ContainerDimensionsContextProvider,
  useIsBreakpointActive,
} from '@therms/atalaya'
import {DesktopLeftMenu} from '../components/DesktopLeftMenu'
import {MobileNav} from '@src/modules/Layout/components/MobileNav'
import {useCurrentUser, useWindowSize} from '@therms/react-modules'

interface AppLayoutContainerProps {
  children: React.ReactNode
}

function AppLayoutContainer({children}: AppLayoutContainerProps) {
  const {width} = useWindowSize()
  const menuRef = useRef<HTMLDivElement>(null)
  const mainRef = useRef<HTMLDivElement>(null)
  const isLgDisplay = useIsBreakpointActive('md')
  const user = useCurrentUser()

  return (
    <div className="flex h-full">
      {isLgDisplay &&
        (user.anp.locations.all ||
          user.anp.locations.locationAndGroupIds.length > 1) && (
          <DesktopLeftMenu ref={menuRef} />
        )}

      <div
        className="relative flex flex-1 flex-col overflow-y-auto"
        style={{
          // we set the width explicitly so children don't cause horizontal scroll
          width: width - (menuRef?.current?.getBoundingClientRect().width || 0),
        }}
      >
        <ContainerDimensionsContextProvider containerRef={mainRef} asViewport>
          <main className="h-full overflow-y-auto" ref={mainRef}>
            {children}
          </main>
        </ContainerDimensionsContextProvider>
        {!isLgDisplay && <MobileNav />}
      </div>
    </div>
  )
}

export {AppLayoutContainer}
